import { Injectable } from '@angular/core';
import { HttpService } from '../../../../shared/services/http/http-client.service';
import { environment } from '../../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class OperacoesAgendadasService {

  constructor(
    private httpService: HttpService
    ) { }

  agendarSaldo(data: any, successHandle:Function, errorHandle:Function) {

    this.httpService.doGet('/employee/product/scheduleChargeBalance', data, successHandle, errorHandle);

  }

  cancelAgendamento(data: any, successHandle:Function, errorHandle:Function) {

    this.httpService.doDelete('/employee/product/scheduleChargeBalance/' + data, successHandle, errorHandle);

  }
}
